__turbopack_context__.v({
  "card": "_8ihYyG_card",
  "custom-columns-container": "_8ihYyG_custom-columns-container",
  "description": "_8ihYyG_description",
  "description-text": "_8ihYyG_description-text",
  "explanations": "_8ihYyG_explanations",
  "has-green-border": "_8ihYyG_has-green-border",
  "hero": "_8ihYyG_hero",
  "settlement": "_8ihYyG_settlement",
  "title": "_8ihYyG_title",
});
